module.exports = {
  eventCategory: 'Editor UI | Tool Menu | text',
  eventAction: 'text_edit',

  toggleBoldFontEvent: { eventLabel: 'toggle_bold' },
  toggleItalicFontEvent: { eventLabel: 'toggle_italic' },
  toggleOptionsEvent: { eventLabel: 'toggle_options' },
  endEditingEvent: { eventLabel: 'change_content' },
  toggleUnderlineFontEvent: { eventLabel: 'toggle_underline' },
  clickEvent: { eventAction: 'add_click' },
  mouseUpEvent: { eventAction: 'add_drop' },

  changeFontFamilyEvent: function (event) {
    var fontFamily = $(event.currentTarget).css('font-family');

    this.trackEvent({
      eventLabel: 'change_font_family ' + this.getQuoteScaped(fontFamily)
    });
  }
};
